import { File05, MagicWand01, MessageTextSquare02, Send01 } from "@untitledui/icons";
import { Plus } from "lucide-react";
import { useState } from "react";
import { useMessageTemplatesCount } from "@/api/message-templates";
import { useDismissHero } from "@/api/user-preferences";
import { PageHero, PageHeroKey } from "@/components/application/page-hero/page-hero";
import { Button } from "@/components/base/buttons/button";
import { LoadingPageState } from "@/components/loading-page-state";
import { PageLayout } from "@/components/page-layout";
import { MessageTemplatesEmptyState } from "./message-templates-empty-state";
import { MessageTemplatesList } from "./message-templates-list";
import { TemplateEditorDialog } from "./template-editor-dialog";

export function MessageTemplates() {
  const [createOpen, setCreateOpen] = useState(false);
  const { data: total, isLoading } = useMessageTemplatesCount();
  const dismissHero = useDismissHero();

  if (isLoading) return <LoadingPageState />;

  if (total === 0) {
    return (
      <>
        <MessageTemplatesEmptyState onNewTemplate={() => setCreateOpen(true)} />
        <TemplateEditorDialog
          open={createOpen}
          onOpenChange={setCreateOpen}
          onCreated={() => dismissHero.mutate(PageHeroKey.MessageTemplates)}
        />
      </>
    );
  }

  return (
    <PageLayout
      title="Message Templates"
      icon={MessageTextSquare02}
      subtitle="Create reusable messages that can be sent manually or as part of a sequence"
      callToAction={
        <Button color="primary" iconLeading={<Plus className="w-4 h-4" />} onClick={() => setCreateOpen(true)}>
          New Template
        </Button>
      }
    >
      <PageHero
        pageKey={PageHeroKey.MessageTemplates}
        title="Write a message once, reuse it everywhere."
        text1={{ icon: File05, message: "Save the messages you send most often." }}
        text2={{ icon: MagicWand01, message: "Use variables to make messages dynamic to creators." }}
        text3={{ icon: Send01, message: "Use a template in any conversation or sequence step." }}
        image="/heroes/message-templates.png"
      />
      <MessageTemplatesList />

      <TemplateEditorDialog open={createOpen} onOpenChange={setCreateOpen} />
    </PageLayout>
  );
}
